import { createActionFactory, Feature } from '../../shared';
import type { Dispatch } from 'redux';
import type { ReadOnlyOwaUserConfiguration } from 'owa-service/lib/ReadOnlyTypes';
import ContactsAPIClient from 'owa-contacts-api';
import { parsePeopleHubOptions } from '../utils/peopleHubOptionsParser';
import { debouncedSerializeAndPersistPeopleHubOptions } from '..';

export const shouldResetCAPIv3Setting = (isCAPIv3Enabled: boolean | undefined) => {
    // make sure we reset this setting to 'undefined' if the capiv3 flight is off
    return !ContactsAPIClient.isEnabled() && isCAPIv3Enabled !== undefined;
};

export const userConfigurationReceivedAction = createActionFactory<{
    userConfig: ReadOnlyOwaUserConfiguration;
}>('UserConfigurationReceivedAction', Feature.Bootstrap);

export const initUserConfiguration = (
    dispatch: Dispatch,
    userConfig: ReadOnlyOwaUserConfiguration
) => {
    dispatch(userConfigurationReceivedAction({ userConfig }));
    const isCAPIv3Enabled = parsePeopleHubOptions(userConfig)?.isCAPIv3Enabled;
    if (shouldResetCAPIv3Setting(isCAPIv3Enabled)) {
        debouncedSerializeAndPersistPeopleHubOptions(dispatch);
    }
};
export type { Action } from '../../shared';
